import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import Sidebar from '../components/Sidebar';

export default function PautaConsultar() {
  const [atividades, setAtividades] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [colunasList, setColunasList] = useState([]);
  const [buscaNome, setBuscaNome] = useState('');
  const [buscaCnpj, setBuscaCnpj] = useState('');
  const navigate = useNavigate();

  const corPorPauta = {
    'Em Prospecção': '#7b1fa2',
    'Em Andamento': '#1976d2',
    'Aguardando Registro': '#f57c00',
    'Aguardando Financeiro': '#0097a7',
    'Finalizado': '#388e3c',
  };

  const rotaPorPauta = {
    'Em Prospecção': '/pauta/prospeccao',
    'Em Andamento': '/pauta/andamento',
    'Aguardando Registro': '/pauta/registro',
    'Aguardando Financeiro': '/pauta/financeiro',
    'Finalizado': '/pauta/finalizado',
  };

  const campoLabels = {
    razao_social: 'Cliente',
    status_pauta: 'Pauta',
    status_detalhe: 'Detalhe',
    preco_final: 'Preço Cliente',
    custo_total: 'Custas',
    protocolo_dbe: 'Protocolo DBE/Viabilidade',
    protocolo_junta: 'Protocolo Junta',
    protocolo_prefeitura: 'Protocolo Prefeitura/Licenciamento',
    data_para_pagamento: 'Data Pagamento',
    numero_nfe: 'NF-e',
    numero_boleto: 'Boleto',
    junta_comercial: 'Local/Junta/Prefeitura',
    status_pagamento_nf: 'Pgto NF',
    status_pagamento_custas: 'Pgto Custas',
    data_abertura: 'Criado em',
    data_alteracao: 'Alterado em',
  };

  useEffect(() => { init(); }, []);

  async function init() {
    const [ativ, cli, colunasRes] = await Promise.all([
      api.get('/atividades/consultar'),
      api.get('/clientes/'),
      api.get('/parametros/coluna_Consultar').catch(() => ({ data: [] })),
    ]);
    setAtividades(ativ.data);
    setClientes(cli.data);
    setColunasList(colunasRes.data.map(c => c.valor));
  }

  async function buscar() {
    const res = await api.get(`/atividades/consultar?nome=${buscaNome}&cnpj=${buscaCnpj.replace(/\D/g, '')}`);
    setAtividades(res.data);
  }

  function limpar() {
    setBuscaNome('');
    setBuscaCnpj('');
    init();
  }

  function nomeCliente(id) {
    const c = clientes.find(c => c.id === id);
    return c ? c.razao_social : '-';
  }

  function cnpjCliente(id) {
    const c = clientes.find(c => c.id === id);
    if (!c) return '-';
    const nums = c.cpf_cnpj.replace(/\D/g, '');
    return nums
      .replace(/^(\d{2})(\d)/, '$1.$2')
      .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1/$2')
      .replace(/(\d{4})(\d)/, '$1-$2');
  }

  function formatarData(dt) {
    if (!dt) return '—';
    return new Date(dt).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  }

  function mascaraCnpj(valor) {
    return valor.replace(/\D/g, '').slice(0, 14)
      .replace(/^(\d{2})(\d)/, '$1.$2')
      .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1/$2')
      .replace(/(\d{4})(\d)/, '$1-$2');
  }

  function irParaPauta(a) {
    const rota = rotaPorPauta[a.status_pauta];
    if (rota) navigate(`${rota}?edit=${a.id}`);
  }

  function valorCelula(a, campo) {
    switch(campo) {
      case 'razao_social': return nomeCliente(a.cliente_id);
      case 'cnpj': return cnpjCliente(a.cliente_id);
      case 'status_pauta': return (
        <span style={{ padding: '3px 8px', borderRadius: '20px', fontSize: '11px', fontWeight: '500', backgroundColor: (corPorPauta[a.status_pauta] || '#888') + '22', color: corPorPauta[a.status_pauta] || '#888' }}>
          {a.status_pauta}
        </span>
      );
      case 'status_detalhe': return a.status_detalhe || '—';
      case 'preco_final': return `R$ ${Number(a.preco_final || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`;
      case 'custo_total': return `R$ ${Number(a.custo_total || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`;
      case 'protocolo_dbe': return a.protocolo_dbe || '-';
      case 'protocolo_junta': return a.protocolo_junta || '-';
      case 'protocolo_prefeitura': return a.protocolo_prefeitura || '-';
      case 'data_para_pagamento': return a.data_para_pagamento ? new Date(a.data_para_pagamento + 'T12:00:00').toLocaleDateString('pt-BR') : '-';
      case 'numero_nfe': return a.numero_nfe || '-';
      case 'numero_boleto': return a.numero_boleto || '-';
      case 'junta_comercial': return a.junta_comercial || '-';
      case 'status_pagamento_nf': return <span style={{ color: a.status_pagamento_nf === 'pago' ? '#388e3c' : '#f57c00', fontSize: '12px' }}>{a.status_pagamento_nf}</span>;
      case 'status_pagamento_custas': return <span style={{ color: a.status_pagamento_custas === 'pago' ? '#388e3c' : '#f57c00', fontSize: '12px' }}>{a.status_pagamento_custas}</span>;
      case 'data_abertura': return <span style={{ fontSize: '12px', color: '#888' }}>{formatarData(a.data_abertura)}</span>;
      case 'data_alteracao': return <span style={{ fontSize: '12px', color: '#888' }}>{formatarData(a.data_alteracao)}</span>;
      default: return a[campo] || '-';
    }
  }

  return (
    <div style={styles.container}>
      <Sidebar />
      <div style={styles.conteudo}>
        <div style={styles.header}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{ ...styles.corIndicador, backgroundColor: '#546e7a' }} />
            <h1 style={styles.titulo}>Consultar</h1>
            <span style={styles.contador}>{atividades.length}</span>
          </div>
        </div>

        <div style={styles.buscaContainer}>
          <input
            style={styles.inputBusca}
            placeholder="Buscar por nome..."
            value={buscaNome}
            onChange={e => setBuscaNome(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && buscar()}
          />
          <input
            style={styles.inputBusca}
            placeholder="Buscar por CNPJ..."
            value={buscaCnpj}
            onChange={e => setBuscaCnpj(mascaraCnpj(e.target.value))}
            maxLength={18}
            onKeyDown={e => e.key === 'Enter' && buscar()}
          />
          <button style={styles.botaoBuscar} onClick={buscar}>Buscar</button>
          <button style={styles.botaoLimpar} onClick={limpar}>Limpar</button>
        </div>

        <table style={styles.tabela}>
          <thead>
            <tr>
              <th style={styles.th}>#</th>
              {colunasList.map(col => (
                <th key={col} style={styles.th}>{campoLabels[col] || col}</th>
              ))}
              <th style={styles.th}></th>
            </tr>
          </thead>
          <tbody>
            {atividades.map(a => (
              <tr key={a.id} style={styles.tr}>
                <td style={styles.td}>{a.id}</td>
                {colunasList.map(col => (
                  <td key={col} style={styles.td}>{valorCelula(a, col)}</td>
                ))}
                <td style={styles.td}>
                  <button style={styles.botaoIr} onClick={() => irParaPauta(a)}>
                    Editar →
                  </button>
                </td>
              </tr>
            ))}
            {atividades.length === 0 && (
              <tr>
                <td colSpan={2 + colunasList.length} style={{ ...styles.td, textAlign: 'center', color: '#aaa', padding: '2rem' }}>
                  Nenhuma atividade encontrada
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const styles = {
  container: { display: 'flex', height: '100vh', overflow: 'hidden', backgroundColor: '#f0f2f5' },
  conteudo: { flex: 1, padding: '2.5rem', overflowY: 'auto' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' },
  corIndicador: { width: '12px', height: '12px', borderRadius: '50%' },
  titulo: { fontSize: '22px', color: '#1a1a2e', margin: 0 },
  contador: { backgroundColor: '#e8eaf6', color: '#3949ab', padding: '2px 10px', borderRadius: '20px', fontSize: '13px', fontWeight: '500' },
  buscaContainer: { display: 'flex', gap: '10px', marginBottom: '1.5rem', flexWrap: 'wrap' },
  inputBusca: { padding: '9px 12px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '14px', flex: 1, minWidth: '200px' },
  botaoBuscar: { backgroundColor: '#1a1a2e', color: '#fff', border: 'none', padding: '9px 20px', borderRadius: '6px', fontSize: '14px', cursor: 'pointer' },
  botaoLimpar: { backgroundColor: 'transparent', color: '#888', border: '1px solid #ddd', padding: '9px 20px', borderRadius: '6px', fontSize: '14px', cursor: 'pointer' },
  tabela: { width: '100%', borderCollapse: 'collapse', backgroundColor: '#fff', borderRadius: '8px', overflow: 'hidden' },
  th: { padding: '12px 16px', textAlign: 'left', fontSize: '12px', color: '#888', borderBottom: '1px solid #f0f0f0', fontWeight: '500' },
  tr: { borderBottom: '1px solid #f0f0f0' },
  td: { padding: '12px 16px', fontSize: '14px', color: '#333' },
  botaoIr: { backgroundColor: 'transparent', color: '#1976d2', border: '1px solid #1976d2', padding: '5px 12px', borderRadius: '4px', fontSize: '12px', cursor: 'pointer' },
};